<template>
  <div class="vip-equimp-wrap">
    <div class="equimp-left">
      <el-tree
        ref="tree"
        :data="treeData"
        :props="defaultProps"
        node-key="nodeKey"
        :highlight-current="true"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="handleNodeClick"
      >
        <span
          slot-scope="{ node, data }"
          class="custom-tree-node"
        >
          <span>
            <img
              class="dir-img"
              :src="node.level === 1 ? require('@/assets/images/tree/dir0.png') : require('@/assets/images/tree/dir.png')"
              alt=""
            >
            {{ node.label }}
            <span
              v-if="data.shelfDataCount"
              class="count"
            >({{ data.shelfDataCount }})</span>
          </span>
        </span>
      </el-tree>
    </div>
    <div class="equimp-right">
      <!-- <div class="right-title">设备目录</div> -->
      <div class="right-content">
        <div class="right-item" v-for="item in list" :key="item.id" @click="equimpDetail(item)">
          <div class="con-img">
            <prod-icon :src="item.equipmentImages && item.equipmentImages[0].FileServerPath" :width="173" :height="150"></prod-icon>
          </div>
          <div class="con-title">{{ item.equipmentName }}</div>
          <div class="con-des">
            <span>浏览：{{ item.viewNums }}</span>
          </div>
        </div>
        <el-empty v-if="!list.length" description="暂无设备"></el-empty>
      </div>
    </div>
    <el-drawer
      :title="'设备详情 - ' + equimpData.equipmentName"
      :visible.sync="isEquimpDraw"
      v-if="isEquimpDraw"
      :size="810"
      append-to-body
      @close="isEquimpDraw = false"
    >
      <equimpmentDetail :id="equimpData.id"></equimpmentDetail>
    </el-drawer>
  </div>
</template>

<script>
import { ProductService } from '@/service/outsource'
import ProdIcon from "/@/components/icon/prod-icon.vue";
import equimpmentDetail from '@/views/outsource/attention/vip-company/equimpment-detail.vue'

export default {
  components: {
    equimpmentDetail,
    ProdIcon
  },
  props: ["row"],
  data () {
    return {
      isEquimpDraw: false,
      equimpData: {},  // 当前选中的设备数据
      list: [],
      // 当前选中的目录节点
      selectedNode: {},
      treeData: [],
      // 默认展开的节点 key 数组
      defaultExpandedKeys: ["root"],
      defaultProps: {
        hasChildren: 'hasChildren', // 是否有子节点的标识字段
        children: 'childNodes', // 子节点字段名
        label: 'dirName'        // 显示文本字段名
      }
    }
  },
  mounted() {
    this.getList()
    this.getDirList()
  },
  methods: {
    // -------------- 获取设备数据
    async getList() {
      const res = await ProductService.getEquipment({
        companyId: this.row.CompID ?? this.row.CompId,
        dirId: this.selectedNode?.iD || 0
      })
      this.list = res.data.list
    },

    // ------------ 获取目录
    async getDirList() {
      const res = await ProductService.getEquipmentDirList({
        companyId: this.row.CompID ?? this.row.CompId,
      })
      this.treeData = [{
        dirName: "设备目录",
        iD: -1,
        nodeKey: 'root',
        childNodes: []
      }]
      this.treeData[0].childNodes = this.adaptForCascader(this.listToTree(res.data))
    },

    // 节点点击事件
    handleNodeClick (data, node) {
      this.selectedNode = data
      this.$refs.tree.setCurrentKey(data.value)
      this.getList();
    },

    // ------------- 进入设备详情
    equimpDetail(item) {
      this.equimpData = item;
      this.isEquimpDraw = true;
    },

    /**
     * 适配 el-cascader 组件的数据格式
     * @param {Array} tree - 树形结构数据
     * @param level - 超出几级就忽略后面的层级，目前是4级
     * @returns {Array} 适配后的数据
     */
     adaptForCascader (tree, level = 1) {
      return tree.map(node => {
        const adapted = {
          ...node,
          label: node.dirName,
          value: node.iD,   
        };
        if (node.children && node.children.length > 0) {
          adapted.children = this.adaptForCascader(node.children, level + 1);
        }
        return adapted;
      });
    },

    /**
     * 将扁平化的列表数据转换为树形结构
     * @param {Array} list - 原始数据列表
     * @param {String} idKey - 节点唯一标识字段名，默认 'id'
     * @param {String} pIdKey - 父节点字段名，默认 'pId'
     * @param {String} children - 子节点字段名，默认 'children'
     * @returns {Array} 树形结构数组
     */
    listToTree (list, idKey = 'iD', pIdKey = 'ParentID', children = 'childNodes') {
      const nodeMap = {}; 
      const tree = []; 
      list.forEach(item => {
        nodeMap[item[idKey]] = { ...item, [children]: [] };
      });
      list.forEach(item => {
        const node = nodeMap[item[idKey]];
        if (item[pIdKey] && nodeMap[item[pIdKey]]) {
          nodeMap[item[pIdKey]][children].push(node);
        } else {
          tree.push(node);
        }
      });
      return tree;
    }
  }
}
</script>
<style scoped lang="less">
/deep/ .el-drawer__header {
  color: black;
  font-weight: bold;
}
.vip-equimp-wrap {
  color: #333;
  padding: 0 10px;
  height: 100%;
  display: flex;

  /deep/ .el-tree-node__content {
    margin-bottom: 3px;
  }
  /deep/ .el-tree-node {
    height: 30px;
    line-height: 30px;
  }

  .equimp-left {
    width: 210px;
    height: 100%;
    background: white;
    padding: 10px;
    font-size: 14px;
    .dir-img {
      width: 18px;
      position: relative;
      top: 4px;
      margin-right: 3px;
    }
  }
  .equimp-right {
    width: calc(100% - 210px);
    height: 100%;
    margin-left: 20px;
    .right-title {
      margin-bottom: 20px;
    }
    .right-content {
      display: flex;
      flex-wrap: wrap;
      .right-item {
        width: 173px;
        height: 213px;
        border: 1px solid #e1e2e6;
        background: white;
        margin-right: 15px;
        margin-bottom: 10px;
        overflow: hidden;
        .con-img {
          width: 100%;
          height: 150px;
        }
        .con-title {
          margin: 10px 0;
          padding: 0 10px;
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .con-des {
          padding: 0 10px;
          font-size: 12px;
          color: gray;
        }
      }
    }
  }
}
</style>